//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import personalInfo from './personalInfo';
import shippingAddress from './shippingAddress';
export default {
    components: {
        personalInfo,
        shippingAddress
    },
    data() {
        return {
            currentSelected: 0 // 0 个人信息;  1 收货地址；2 头像设置
        };
    },
    methods: {
        // 切换设置内容
        switchTab(index_) {
            this.currentSelected = index_;
            this.$router.push('/mallPersonalSettings?code='+index_);
        },
        // 设置头像
        changeAvatar() {
            this.switchTab(2);
            
        }
    },
    mounted() {
        var code = this.$route.query.code;
        this.switchTab(code);
    }
};



// WEBPACK FOOTER //
// ./src/pcComponents/mine/personalSettings/index.vue